<div class="login-container">
  <!-- Left Panel -->
  <div class="left-panel">

    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png">
      <img src="assets/dashboard icons/logo2.png">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png">
      <img src="assets/dashboard icons/logo4.png">
      <img src="assets/dashboard icons/logo5.png">
    </div>

    <!-- <div class="left-panel-text">
      Accredited Social Health Activists
    </div> -->
    <div class="left-panel-text">
      {{ langService.currentLang === 'mr'
      ? 'मान्यताप्राप्त सामाजिक आरोग्य कार्यकर्त्या'
      : 'Accredited Social Health Activists' }}
    </div>
    <img src="assets/dashboard icons/AshaPic.png" alt="Asha" />
  </div>

  <div class="right-container">
    <div class="login-card">
      <!-- Desktop logo -->
      <img src="assets/icons/headericon_pink.png" alt="Asha" />
      <!-- <h2 class="login-title">Forgot your Password</h2> -->
      <h2 class="login-title">{{ titleText }}</h2>

      <!-- Mobile replacement image -->
      <img src="assets/loginImg.png" alt="Asha" class="mobile-login-image" />
      <!-- <p class="login-subtitle">Enter your Email ID so that we can send you <br> password reset link</p> -->
      <p class="login-subtitle">{{ subtitleText }}</p>

      <form class="login-form">

        <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top" class="custom-login-form"
          [showColonAfterLabel]="false">

          <dxi-form-item dataField="email" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
placeholder: langService.currentLang === 'mr'
    ? 'तुमचा ईमेल आयडी टाका'
    : 'Enter your Email Id',              
    buttons: [{
                name: 'userIcon',
                id: 'email',
                value: formData.email,
                location: 'after',
                options: { icon: 'custom-user-icon' }
              }]
            }">
            <!-- <dxo-label text="Email ID"></dxo-label> -->
            <dxo-label [text]="langService.currentLang === 'mr' ? 'ईमेल आयडी' : 'Email ID'"></dxo-label>
          </dxi-form-item>
        </dx-form>

        <dx-button [text]="langService.currentLang === 'mr' ? 'ओटीपी पाठवा' : 'Send OTP'" type="default"
          stylingMode="contained" class="login-button" (click)="ForgetPassword()"></dx-button>

        <div class="forgot-password-text">
          <!-- <a (click)="NavigateToLogin()">&lt; Back to login</a> -->
          <a (click)="NavigateToLogin()">
            {{ langService.currentLang === 'mr' ? '← लॉगिनकडे परत जा' : '< Back to login' }} </a>
        </div>
      </form>
    </div>
  </div>
</div>